import app from './App';
import * as api from './Api';

export default { ...app, ...api };
